import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import '@datadog/browser-logs/bundle/datadog-logs'
//below is for javascript implementation (not TS)
// import { datadogLogs } from '@datadog/browser-logs';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();  

}


// window.DD_LOGS.init({
//   clientToken: environment.dataDogLoggerConfig.clientToken,
//   site: environment.dataDogLoggerConfig.site,
//   forwardErrorsToLogs: true,
//   sessionSampleRate: 100,
// })

//below is for javascript implementation (not TS)

// datadogLogs.init({
//   clientToken: environment.dataDogLoggerConfig.clientToken,
//   site: environment.dataDogLoggerConfig.site,
//   forwardErrorsToLogs: true,
//   sampleRate: 100,
// });

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
